import React, {Component} from 'react'
import {Alert} from 'react-bootstrap'
import {observer, inject} from 'mobx-react'

class Alerts extends Component {
    render() {
        const {stores} = this.props
        const {store} = stores
        // const authError = authStore.authError()

        return (
            <div>
                {store.errorAlert &&
                    <div className='headerSymbol'>
                        <div className='headerStatus'>
                            <Alert bsStyle='danger'>
                                {store.errorAlert}
                            </Alert>
                        </div>
                    </div>
                }
                {store.infoAlert &&
                    <div className='headerSymbol'>
                        <div className='headerStatus'>
                            <Alert bsStyle='info'>
                                {store.infoAlert}
                            </Alert>
                        </div>
                    </div>
                }
                {/* {authError &&
                    <div className='headerSymbol'>
                        <div className='headerStatus'>
                            <Alert bsStyle='danger'>
                                API Error: {JSON.stringify(authError)}
                            </Alert>
                        </div>
                    </div>
                } */}
            </div>
        )
    }
}

export default inject("stores")(observer(Alerts))



// WEBPACK FOOTER //
// ./src/containers/Alerts.js